import React from "react";

const PrivateGPFeesCheckListContent = {
  checklistText: <p>Before you start, please have the following ready:</p>,
  checklist: ["Invoices, receipts for your appointment"],
  checklistSLA:
    "Once you've submitted your documents, please allow up to 10 working days for us to review them.",
  infoBoxIconClass: "icon-help-outline"
};

const SMEPrivateGPFees = {
  HOL: {
    ...PrivateGPFeesCheckListContent,
    checklistText: <p>Before you start, please have the following ready:</p>
  },
  Any: PrivateGPFeesCheckListContent
};

export default SMEPrivateGPFees;
